import { Box, Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import usePromotionsList from './promotions-list.hook';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';
import { paths } from 'src/routes/paths';
import { useMyDataStore } from 'src/store/me/me.store';

export default function PromotionsList() {
  const { TABLEHEADER, isLoadingPromotionsList, promotionsList, navigate } = usePromotionsList();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.benefits);

  return (
    <Page title="Lista de Sorteios">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Sorteios"
          links={[]}
          action={
            <Button
              variant="contained"
              onClick={() => navigate(paths.dashboard.promotionCreate)}
              disabled={!permissions?.create}
            >
              Cadastrar Sorteio
            </Button>
          }
        />
        {isLoadingPromotionsList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={promotionsList}
            header={TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => navigate(paths.dashboard.promotionDetails(id))}
            avatarType="default"
            avatarKey="image"
          />
        )}
      </Container>
    </Page>
  );
}
